import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export function DialogCloseButton({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  return (
    <IconButton
      sx={{ position: "absolute", top: "17px", right: "17px" }}
      onClick={onClick}
      disabled={disabled}
      data-testid="dialog-close-button"
      aria-label="Schließen"
    >
      <CloseIcon sx={{ color: "text.secondary" }} />
    </IconButton>
  );
}
